<div class="page-content">
  <app-search-form
    [config]="config$ | async"
    (hotelChange)="onHotelChange($event)"
    (submitted)="onSearchFormSubmit($event)"></app-search-form>
</div>
